"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReviewSummaryWorkbook = exports.createQALogWorkbook = exports.createMultiRunWorkBook = void 0;
const xlsx_1 = __importDefault(require("xlsx"));
const handlers_1 = require("./handlers");
const utils_1 = require("./utils");
const ReviewQALogParser_1 = __importDefault(require("./handlers/ReviewQA/ReviewQALogParser"));
const ReviewQALogBuilder_1 = __importDefault(require("./handlers/ReviewQA/ReviewQALogBuilder"));
const ReviewSummaryParser_1 = __importDefault(require("./handlers/ReviewSummary/ReviewSummaryParser"));
const ReviewSummaryBuilder_1 = __importDefault(require("./handlers/ReviewSummary/ReviewSummaryBuilder"));
const defaultOptions = {
    hideBase: false,
    hideRaw: false,
    hideNotes: false,
    cqOnly: false,
};
/**
 *
 * @param parser (DataParser) the created parser class
 * @returns boolean
 */
function validParser(parser) {
    return (parser instanceof handlers_1.Three9PortalParser ||
        parser instanceof handlers_1.Three9AppParser ||
        parser instanceof handlers_1.Two3PortalParser);
}
/**
 *
 * @param builder (Builder) the created builder class
 * @returns boolean
 */
function validBuilder(builder) {
    return builder instanceof handlers_1.Three9Builder || builder instanceof handlers_1.Two3Builder;
}
/**
  @param initialRunData - initial data in format array of { run, protocol , standardCurve }. Details are in Models.
  @param parsing - parsing string
  @param options - object with predefined bool values. Pass true to choose options.
  @param optionalData - array of extraSection. See details in run models.
*/
function createMultiRunWorkBook(initialRunData, parsing, options = defaultOptions) {
    // let runsData = formatAllInOne(initialRunData, parsing);
    let builder = new handlers_1.Builder();
    let parser = new handlers_1.DataParser();
    switch (parsing) {
        case "portal-three9": {
            parser = new handlers_1.Three9PortalParser(); // Heidi here problem
            builder = new handlers_1.Three9Builder();
            break;
        }
        case "app-three9": {
            parser = new handlers_1.Three9AppParser();
            builder = new handlers_1.Three9Builder();
            break;
        }
        case "portal-two3": {
            parser = new handlers_1.Two3PortalParser();
            builder = new handlers_1.Two3Builder();
            break;
        }
    }
    if (parser instanceof handlers_1.DataParser && !validParser(parser)) {
        throw "Invalid Parsing Type found";
    }
    if (builder instanceof handlers_1.Builder && !validBuilder(builder)) {
        throw "Invalid Builder Type found";
    }
    let format = "detailed";
    if (options.cqOnly == true) {
        format = "summary";
    }
    let parsedData = parser.parse(initialRunData);
    let formattedData = parser.format(parsedData);
    let data = [];
    let workbook = new handlers_1.Workbook();
    if (options.cqOnly) {
        data = builder.buildSummary(formattedData);
        workbook.addSheet((0, utils_1.sheet_from_array_of_arrays)(data, options), "Summary");
    }
    else {
        data = builder.buildDetailed(formattedData);
        for (let item of data) {
            let dataArray = builder.layout(item);
            workbook.addSheet((0, utils_1.sheet_from_array_of_arrays)(dataArray, options), item.sheetName);
        }
    }
    let wboptions = {
        bookType: "xlsx",
        bookSST: false,
        type: options.type || "base64",
    };
    let wbout = xlsx_1.default.write(workbook, wboptions);
    return wbout;
}
exports.createMultiRunWorkBook = createMultiRunWorkBook;
/**
 * Utility for generating review QA logs
 * @param reviewData All of the review data associated with the run
 * the QA log is for
 * @returns {ArrayBuffer} The generated XLSX in an ArrayBuffer
 */
function createQALogWorkbook(reviewData) {
    const parser = new ReviewQALogParser_1.default(reviewData);
    const builder = new ReviewQALogBuilder_1.default(parser.getFormattedSampleRuns());
    const wbOptions = {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
    };
    const workbook = new handlers_1.Workbook();
    workbook.addSheet((0, utils_1.sheet_from_array_of_arrays)(builder.getSampleRunLog()), "Sample Run Log");
    const wbOut = xlsx_1.default.write(workbook, wbOptions);
    return (0, utils_1.stringToArrayBuffer)(wbOut);
}
exports.createQALogWorkbook = createQALogWorkbook;
/**
 * Utility for generating review summary for OHL auditing records
 * @param reviewData All of the review data associated with the run
 * the summary is for
 * @returns {ArrayBuffer} The generated XLSX in an ArrayBuffer
 */
function createReviewSummaryWorkbook(reviewData) {
    const parser = new ReviewSummaryParser_1.default(reviewData);
    const builder = new ReviewSummaryBuilder_1.default(parser.getReviewTargetNames(), parser.getParsedAndFormattedReviewSamples());
    const wbOptions = {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
    };
    const workbook = new handlers_1.Workbook();
    workbook.addSheet((0, utils_1.sheet_from_array_of_arrays)(builder.getReviewSummary()), "Review Summary");
    const wbOut = xlsx_1.default.write(workbook, wbOptions);
    return (0, utils_1.stringToArrayBuffer)(wbOut);
}
exports.createReviewSummaryWorkbook = createReviewSummaryWorkbook;
